import { useAttributionParams } from '@lib/tracking/attribution'
import React, { useMemo } from 'react'

import CivicCookie from '../../components/civicCookie'
import { useSiteConfig } from '../siteconfig'
import { Analytics, create } from './analytics'
import AnalyticsContext from './AnalyticsContext'

const AnalyticsProvider = ({ children }: { children: React.ReactNode }) => {
  const {
    baseGoogleAnalyticsTrackingId,
    googleAnalyticsLinkerDomains,
    googleAnalyticsTrackingId,
    googleTagManagerId,
    siteTitle,
    matomoSiteId,
    matomoTagManagerContainerId,
    matomoUrl,
    segmentId,
  } = useSiteConfig()

  const siteShortTitle = () => {
    if (siteTitle === 'Collision') return 'coll'
    if (siteTitle === 'Web Summit') return 'ws'
    if (siteTitle === 'RISE') return 'rc'
    return 'ws'
  }

  useAttributionParams()

  const analytics = useMemo<Analytics>(
    () =>
      create({
        baseGoogleAnalyticsTrackingId,
        googleAnalyticsLinkerDomains,
        googleAnalyticsTrackingId,
        googleTagManagerId,
        matomoSiteId,
        matomoTagManagerContainerId,
        matomoUrl,
        segmentId,
      }),
    [
      baseGoogleAnalyticsTrackingId,
      googleAnalyticsLinkerDomains,
      googleAnalyticsTrackingId,
      googleTagManagerId,
      matomoSiteId,
      matomoTagManagerContainerId,
      matomoUrl,
      segmentId,
    ]
  )

  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
      <CivicCookie bannerStyle={siteShortTitle()} />
    </AnalyticsContext.Provider>
  )
}

export default AnalyticsProvider
